/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  ICurveLPTokensDetailsFetchersRepository,
  ICurveLPTokensDetailsFetchersRepositoryInterface,
} from "../ICurveLPTokensDetailsFetchersRepository";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "contract ICurveLPTokensDetailsFetcher",
        name: "fetcher",
        type: "address",
      },
    ],
    name: "FetcherAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "contract ICurveLPTokensDetailsFetcher",
        name: "fetcher",
        type: "address",
      },
    ],
    name: "FetcherRemoved",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "contract ICurveLPTokensDetailsFetcher",
        name: "_fetcher",
        type: "address",
      },
    ],
    name: "addFetcher",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "curveLPTokensFetchersRepositoryPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "getFetchers",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_lpToken",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "getLPTokenDetails",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "address",
                name: "addr",
                type: "address",
              },
              {
                internalType: "bool",
                name: "isMeta",
                type: "bool",
              },
            ],
            internalType: "struct Pool",
            name: "pool",
            type: "tuple",
          },
          {
            internalType: "address[]",
            name: "coins",
            type: "address[]",
          },
        ],
        internalType: "struct LPTokenDetails",
        name: "details",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_lpToken",
        type: "address",
      },
    ],
    name: "getLPTokenPool",
    outputs: [
      {
        internalType: "address",
        name: "pool",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ICurveLPTokensDetailsFetcher",
        name: "_fetcher",
        type: "address",
      },
    ],
    name: "removeFetcher",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class ICurveLPTokensDetailsFetchersRepository__factory {
  static readonly abi = _abi;
  static createInterface(): ICurveLPTokensDetailsFetchersRepositoryInterface {
    return new utils.Interface(
      _abi
    ) as ICurveLPTokensDetailsFetchersRepositoryInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ICurveLPTokensDetailsFetchersRepository {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ICurveLPTokensDetailsFetchersRepository;
  }
}
